import {isString} from 'lodash';

import {nativeInterfaceUtils} from 'utils';

import {ClientNotifier} from '../ClientNotifier';

export class SDKMethodNotifier extends ClientNotifier {
    notify = nativeInterfaceUtils.callNativeInterfaceMethodWrapper;
    formatResult = nativeInterfaceUtils.formatNativeInterfaceMethodResult;
}

export class IosSDKEventNotifier extends ClientNotifier {
    notify = nativeInterfaceUtils.sendNativeInterfaceEvent;
    formatResult = nativeInterfaceUtils.formatNativeInterfaceEventResult;
}

export class AndroidSDKEventNotifier extends ClientNotifier {
    notify = (name: string, data: any) =>
        nativeInterfaceUtils.sendNativeInterfaceEvent(name, isString(data) ? data : JSON.stringify(data), {stringify: true});

    formatResult = nativeInterfaceUtils.formatNativeInterfaceEventResult;
}
